import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {Flur} from "../../../model/flur";
import {Landregisterfolio} from "../../../model/landregisterfolio";
import {Flurstueck} from "../../../model/flurstueck";
import * as $ from 'jquery';
import {Property} from "../../../model/property";
import {CustomValidators} from "../../../CustomValidators";
import {LoginIdService} from "../../../service/login-id.service";
import {alphanumericValidator} from "../../../utils/alphanumeric-validator";
import {PricingUtils} from "../../../utils/pricing-utils";

@Component({
  selector: 'app-property-form',
  templateUrl: './property-form.component.html',
  styleUrls: ['./property-form.component.css']
})
export class PropertyFormComponent implements OnInit{
  mobile: boolean = false;

  constructor(private readonly formBuilder: UntypedFormBuilder, private readonly loginIdService: LoginIdService,
              private readonly cdref: ChangeDetectorRef) {
  }

  @Input() property: Property;
  @Input() insideCi: boolean = false;
  @Input() toNextPage: boolean;
  @Input() showCheckbox: boolean;
  @Input() disabled: boolean;
  @Input() isOwnerResearch: boolean = false;
  @Input() shouldHaveLandregisterValidators: boolean = false;
  @Input() shouldDisplayFolioNumber: boolean = true;
  propertyForm: UntypedFormGroup;
  ownerForm: UntypedFormGroup;
  researchAmount;
  ownerResearchSubscription;
  gemarkungValidator = [Validators.required, Validators.maxLength(145), alphanumericValidator()];
  flurstueckValidator = [Validators.required, Validators.maxLength(500), alphanumericValidator()];
  folioValidator = [Validators.required, Validators.minLength(1), Validators.maxLength(500), alphanumericValidator()];


  async ngOnInit(): Promise<void> {
    if (!this.property) {
      this.property = new Property();
    }

    await this.loginIdService.loginServiceInitialized$.toPromise();

    this.researchAmount = PricingUtils.getResearchAmount();
    this.initializeOwnerForm();
    this.initializePropertyForm();
    this.subscribeToDataResearchChanges();
    this.subscribeToOwnerFormChanges();

    if (this.disabled) {
      this.propertyForm.disable();
    }

    this.cdref.detectChanges();
  }

  hasError(control: AbstractControl): boolean {
    return (control.invalid && (control.touched || this.toNextPage));
  }

  initFolio(folio: Landregisterfolio) {
    return new UntypedFormGroup({
      number: new UntypedFormControl(folio.number, this.shouldHaveLandregisterValidators ? this.folioValidator : null),
      gemarkung: new UntypedFormControl(folio.gemarkung, this.shouldHaveLandregisterValidators ? this.gemarkungValidator : null),
      flure: this.formBuilder.array(this.createFlur(folio))
    });
  }

  createFolios(): AbstractControl[] {
    let result: AbstractControl[] = [];
    let that = this;
    this.property.landregisterfolios.forEach(function (folio) {
      result.push(that.initFolio(folio));
    });
    return result;
  }

  createFlur(folio: Landregisterfolio): Array<UntypedFormGroup> {
    let result: Array<UntypedFormGroup> = [];
    let that = this;
    folio.flure.forEach(function (flur) {
      result.push(that.initFlur(flur));
    });
    return result;
  }

  initFlur(flur: Flur) {
    return this.formBuilder.group({
      number: new UntypedFormControl(flur.number),
      flurstuecke: this.formBuilder.array(this.createFlurstuecke(flur))
    });
  }

  createFlurstuecke(flur: Flur): Array<UntypedFormGroup> {
    let result: Array<UntypedFormGroup> = [];
    let that = this;
    flur.flurstuecke.forEach(function (fs) {
      result.push(that.initFlurstueck(fs));
    });

    return result;
  }

  initFlurstueck(fs: Flurstueck) {
    return this.formBuilder.group({
      number: new UntypedFormControl(fs.number, this.shouldHaveLandregisterValidators ? this.flurstueckValidator : null),
      geometry: new UntypedFormControl(fs.geometry)
    });
  }

  getFolios(form) {
    return form.controls.landregisterfolios.controls;
  }

  getFlure(form) {
    return form.controls.flure.controls;
  }

  getFlurstuecke(form) {
    return form.controls.flurstuecke.controls;

  }

  addFolio() {
    const control = <UntypedFormArray>this.propertyForm.get('landregisterfolios');
    control.push(this.initFolio(new Landregisterfolio()));
  }

  deleteFolio(i) {
    const control = <UntypedFormArray>this.propertyForm.get('landregisterfolios');
    control.removeAt(i);
  }

  addFlur(j) {
    const group = <UntypedFormGroup>this.propertyForm.get('landregisterfolios');
    let control = <UntypedFormArray>group.controls[j].get('flure');
    control.push(this.initFlur(new Flur()));
  }

  deleteFlur(i, j) {

    const group = <UntypedFormGroup>this.propertyForm.get('landregisterfolios');
    let control = <UntypedFormArray>group.controls[i].get('flure');
    control.removeAt(j);
  }

  addFlurstueck(i, j) {
    const group = <UntypedFormGroup>this.propertyForm.get('landregisterfolios');
    let controlFlure = <UntypedFormArray>group.controls[i].get('flure');
    let controlFlurstueck = <UntypedFormArray>controlFlure.controls[j].get('flurstuecke');
    controlFlurstueck.push(this.initFlurstueck(new Flurstueck()));
  }

  deleteFlurstueck(i, j, k) {
    const control = <UntypedFormArray>this.propertyForm.get(['landregisterfolios', i, 'flure', j, 'flurstuecke']); // also try this new syntax
    control.removeAt(k);
  }

  isTaxProfile(){
    let platformProfile = JSON.parse(sessionStorage.getItem("platform"));
    return platformProfile && platformProfile.platformType === "STEUER";
  }

  /**
   * Updates the form fields and form array in the property form based on the current property values.
   * The method replaces the 'landregisterfolios' FormArray and patches the form fields with corresponding values from the property object.
   */
  public updateFormFromProperty(): void {
    if (this.property && this.propertyForm) {
      // Replace the FormArray with a new one based on updated lanregisterfolios
      this.propertyForm.setControl(
          'landregisterfolios',
          this.formBuilder.array(this.createFolios())
      );

      // Patch basic form fields with corresponding values from the property
      this.propertyForm.patchValue({
        name: this.property.name,
        street: this.property.street,
        house_number: this.property.house_number,
        id: this.property.id,
        zip: this.property.zip,
        town: this.property.town,
        taxNumber: this.property.taxNumber,
        dataResearch: this.property.dataResearch,
        isTeilunObtainableOnSite: this.property.isTeilunObtainableOnSite,
        state: this.property.state,
        dataSource: this.property.dataSource
      });
    }
  }

  /**
   * Updates the property object with values from the property form.
   * The method checks if the property form exists, then assigns its values
   * to the property object, effectively updating the property with form data.
   */
  public updatePropertyWithFormValues(): void {
    if (this.propertyForm) {
      const formProperty = this.propertyForm.value as Property;
      delete formProperty.dataSource;
      Object.assign(this.property, formProperty);
    }
  }

  /**
   * Initializes the owner form with specific controls and validators.
   * Sets up the form group with controls for 'gemarkung', 'flur', and 'flstk',
   * assigning values and validators based on the property state and validation requirements.
   */
  private initializeOwnerForm(): void{
    this.ownerForm = new UntypedFormGroup({
      'gemarkung': new UntypedFormControl(this.property?.landregisterfolios[0]?.gemarkung, this.shouldHaveLandregisterValidators ? this.gemarkungValidator : null),
      'flur': new UntypedFormControl(this.property?.landregisterfolios[0]?.flure[0].number, this.shouldHaveLandregisterValidators ? [Validators.required, Validators.maxLength(500)] : null),
      'flstk': new UntypedFormControl(this.property?.landregisterfolios[0]?.flure[0]?.flurstuecke[0].number, this.shouldHaveLandregisterValidators ? this.flurstueckValidator : null)
    });
  }

  /**
   * Initializes the property form by creating a form group with specific controls and their validations.
   */
  private initializePropertyForm(): void{
    this.propertyForm = this.formBuilder.group({
      name: new UntypedFormControl(this.property.name , [Validators.maxLength(500)]),
      street: new UntypedFormControl(this.property.street,[Validators.required, Validators.maxLength(500)]),
      house_number: new UntypedFormControl(this.property.house_number, [Validators.maxLength(500)]),
      id: new UntypedFormControl(this.property.id),
      zip: new UntypedFormControl(this.property.zip, Validators.compose([
        Validators.required,
        CustomValidators.patternValidator(/^\d{5}$/, { isPlzValid: true })
      ])),
      town: new UntypedFormControl(this.property.town, [Validators.required, Validators.maxLength(140)]),
      taxNumber: new UntypedFormControl(this.property.taxNumber, [Validators.maxLength(255)]),
      isTeilunObtainableOnSite: new UntypedFormControl(this.property.isTeilunObtainableOnSite),
      state: new UntypedFormControl(this.property.state),
      landregisterfolios: this.formBuilder.array(this.createFolios()),
      dataResearch: new UntypedFormControl(this.property.dataResearch),
      dataSource: new UntypedFormControl(this.property.dataSource),
    });
  }

  /**
   * Subscribes to changes in the "dataResearch" field of the property form.
   * Enables or disables validators for the "landregisterfolios" form array based on the value of "dataResearch".
   */
  private subscribeToDataResearchChanges(): void {
    if (this.shouldHaveLandregisterValidators) {
      this.propertyForm.get("dataResearch").valueChanges.subscribe(selectedValue => {
        let folioFormArray = (this.propertyForm.get("landregisterfolios")) as UntypedFormArray
        if (selectedValue) {
          this.disableFolioValidators(folioFormArray);
        } else {
          this.enableFolioValidators(folioFormArray);
        }
      });
    }
  }

  /**
   * Disables and clears validators for form controls in the folioFormArray and related form controls.
   *
   * @param {UntypedFormArray} folioFormArray - The form array containing folios and their nested controls.
   */
  private disableFolioValidators(folioFormArray: UntypedFormArray): void{
    $("#additionalData").slideUp();
    this.propertyForm.get("taxNumber").clearValidators();
    this.propertyForm.get("taxNumber").updateValueAndValidity();
    for (let folio of folioFormArray.controls) {
      folio.get('gemarkung').clearValidators();
      folio.get('gemarkung').updateValueAndValidity();
      folio.get('number').clearValidators();
      folio.get('number').updateValueAndValidity();
      for (let flure of folio.get('flure')['controls']) {
        for (let flstk of flure.get('flurstuecke')['controls']) {
          flstk.get('number').clearValidators();
          flstk.get('number').updateValueAndValidity();

        }
      }
    }
  }

  /**
   * Enables and applies validators to the given folio form array and its nested form controls.
   * Additionally updates the validity of all relevant form controls.
   *
   * @param {UntypedFormArray} folioFormArray - The form array containing folio controls to which validators will be applied.
   */
  private enableFolioValidators(folioFormArray: UntypedFormArray): void{
    $("#additionalData").slideDown();
    if (JSON.parse(sessionStorage.getItem("platform")) && JSON.parse(sessionStorage.getItem("platform")).platformType === "STEUER") {
      this.propertyForm.get("taxNumber").setValidators(Validators.required);
      this.propertyForm.get("taxNumber").updateValueAndValidity();
    }
    for (let folio of folioFormArray.controls) {
      folio.get('gemarkung').setValidators(this.gemarkungValidator);
      folio.get('gemarkung').updateValueAndValidity();
      folio.get('number').setValidators(this.folioValidator);
      folio.get('number').updateValueAndValidity();

      for (let flure of folio.get('flure')['controls']) {
        for (let flstk of flure.get('flurstuecke')['controls']) {
          flstk.get('number').setValidators(this.flurstueckValidator);
          flstk.get('number').updateValueAndValidity();
        }
      }
    }
  }

  /**
   * Subscribes to changes in the owner form and updates the property form
   * with the corresponding values from the owner form.
   */
  private subscribeToOwnerFormChanges(): void{
    this.ownerResearchSubscription = this.ownerForm.valueChanges.subscribe(value => {
      this.propertyForm.patchValue({
        landregisterfolios: [{
          number: '-',
          gemarkung: value.gemarkung,
          flure: [{
            number: value.flur,
            flurstuecke: [{
              number: value.flstk
            }]
          }]
        }]
      });
    });
  }

  fieldIsInvalid(fieldName: string): boolean {
    const field = this.ownerForm.get(fieldName);
    return field.invalid && (field.dirty || field.touched);
  }
}
